module.exports = __webpack_public_path__ + "img/10.c67cd032.png";